'use strict';

var PropTypes = require('prop-types');
var useTheme = require('../styles/useTheme.js');
var withWidth = require('../withWidth/withWidth.js');
var exactProp = require('../../../utils/esm/exactProp.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var PropTypes__default = /*#__PURE__*/_interopDefaultLegacy(PropTypes);

/**
 * @ignore - internal component.
 */

function HiddenJs(props) {
  var children = props.children,
      only = props.only,
      width = props.width;
  var theme = useTheme();
  var visible = true; // `only` check is faster to get out sooner if used.

  if (only) {
    if (Array.isArray(only)) {
      for (var i = 0; i < only.length; i += 1) {
        var breakpoint = only[i];

        if (width === breakpoint) {
          visible = false;
          break;
        }
      }
    } else if (only && width === only) {
      visible = false;
    }
  } // Allow `only` to be combined with other props. If already hidden, no need to check others.


  if (visible) {
    // determine visibility based on the smallest size up
    for (var _i = 0; _i < theme.breakpoints.keys.length; _i += 1) {
      var _breakpoint = theme.breakpoints.keys[_i];
      var breakpointUp = props["".concat(_breakpoint, "Up")];
      var breakpointDown = props["".concat(_breakpoint, "Down")];

      if (breakpointUp && withWidth.isWidthUp(_breakpoint, width) || breakpointDown && withWidth.isWidthDown(_breakpoint, width)) {
        visible = false;
        break;
      }
    }
  }

  if (!visible) {
    return null;
  }

  return children;
}

HiddenJs.propTypes = {
  /**
   * The content of the component.
   */
  children: PropTypes__default["default"].node,

  /**
   * @ignore
   */
  className: PropTypes__default["default"].string,

  /**
   * Specify which implementation to use.  'js' is the default, 'css' works better for
   * server-side rendering.
   */
  implementation: PropTypes__default["default"].oneOf(['js', 'css']),

  /**
   * You can use this prop when choosing the `js` implementation with server-side rendering.
   *
   * As `window.innerWidth` is unavailable on the server,
   * we default to rendering an empty component during the first mount.
   * You might want to use an heuristic to approximate
   * the screen width of the client browser screen width.
   *
   * For instance, you could be using the user-agent or the client-hints.
   * https://caniuse.com/#search=client%20hint
   */
  initialWidth: PropTypes__default["default"].oneOf(['xs', 'sm', 'md', 'lg', 'xl']),

  /**
   * If `true`, screens this size and down will be hidden.
   */
  lgDown: PropTypes__default["default"].bool,

  /**
   * If `true`, screens this size and up will be hidden.
   */
  lgUp: PropTypes__default["default"].bool,

  /**
   * If `true`, screens this size and down will be hidden.
   */
  mdDown: PropTypes__default["default"].bool,

  /**
   * If `true`, screens this size and up will be hidden.
   */
  mdUp: PropTypes__default["default"].bool,

  /**
   * Hide the given breakpoint(s).
   */
  only: PropTypes__default["default"].oneOfType([PropTypes__default["default"].oneOf(['xs', 'sm', 'md', 'lg', 'xl']), PropTypes__default["default"].arrayOf(PropTypes__default["default"].oneOf(['xs', 'sm', 'md', 'lg', 'xl']))]),

  /**
   * If `true`, screens this size and down will be hidden.
   */
  smDown: PropTypes__default["default"].bool,

  /**
   * If `true`, screens this size and up will be hidden.
   */
  smUp: PropTypes__default["default"].bool,

  /**
   * @ignore
   * width prop provided by withWidth decorator.
   */
  width: PropTypes__default["default"].string.isRequired,

  /**
   * If `true`, screens this size and down will be hidden.
   */
  xlDown: PropTypes__default["default"].bool,

  /**
   * If `true`, screens this size and up will be hidden.
   */
  xlUp: PropTypes__default["default"].bool,

  /**
   * If `true`, screens this size and down will be hidden.
   */
  xsDown: PropTypes__default["default"].bool,

  /**
   * If `true`, screens this size and up will be hidden.
   */
  xsUp: PropTypes__default["default"].bool
};

if (process.env.NODE_ENV !== 'production') {
  HiddenJs.propTypes = exactProp["default"](HiddenJs.propTypes);
}

var HiddenJs$1 = withWidth["default"]()(HiddenJs);

module.exports = HiddenJs$1;
